/**
 * Public entry point for `@repo/theme` — the renderer-agnostic core.
 *
 * Tokens, `ThemeProvider`, and `useTheme` flow through here, and everything
 * this barrel re-exports is safe for any React *or* Preact consumer — nothing
 * here imports `react-native`.
 *
 * `createThemedStyles` is deliberately NOT re-exported here: it wraps
 * `react-native`'s `StyleSheet`, so it lives at `@repo/theme/styles` and is
 * imported only by React Native / react-native-web callers. Keeping it off the
 * barrel lets web-only bundles (e.g. the Preact web-component teaser) import
 * theme data and context without dragging `react-native` into their graph.
 */

export {
    parseHexColor,
    toHexColor,
    toHoverColor,
    toPressColor,
    translucentHoverColor,
    translucentPressColor,
} from './color.helpers';
export { ThemeProvider, useTheme } from './context';
export { mergeTheme, tokensToCssVars } from './theme.helpers';
export type { ColorTokens, FontTokens, PartialTheme, SpacingTokens, Theme } from './tokens';
export { DefaultHexColor, defaultTheme } from './tokens';
